module.exports = __webpack_public_path__ + "static/the-quest-for-el-cid-67cbc5d682ace4240ae8a3e8701f2ddb.jpg";